/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormControl,
  Button,
  InputGroup,
  Modal,
  ProgressBar,
  Spinner
} from "react-bootstrap";

import CustomBackground from "../../components/UI/CustomBackground/CustomBackground";

import { useTranslation, Translation } from "react-i18next";

import { ReactComponent as InfoCircleLightIcon } from "../../assets/infoCircleLight.svg";

import graphQLClientInstance from "../../axios-graphql-client";

import axios from "axios";

import Bottleneck from "bottleneck";

import classes from "./SearchVarieties.module.css";

import CustomAsyncTypehead from "../../components/UI/CustomAsyncTypehead/CustomAsyncTypehead";
import CustomDropdown from "../../components/UI/CustomDropdown/CustomDropdown";
import Table, { tableOrigin } from "../../components/UI/Table/Table";
import MultiSelect from "react-multi-select-component";
import CustomDatePicker, { calendarToday } from "../../components/UI/CustomDatePicker/CustomDatePicker";


import { Formik } from "formik";
import * as Yup from "yup";

import CustomSortablePopover from "../../components/UI/CustomSortablePopover/CustomSortablePopover";

import { withRouter } from "react-router-dom";

import useSettings from "../../hooks/useSettings";

import Loader from "../../components/UI/Loader/Loader";

import * as actions from "../../store/actions";

import {
  selectOptions,
  denominationSelectOptions,
  speciesLatinNameSelectOptions,
  denomNatureOptions,
  varietyStatusOptions,
  registerTypeOptions,
  breedersReferenceSelectOptions,
  breederNameSelectOptions,
  partiesSelectOptions,
  applicationNumberSelectOptions,
  speciesClassCodeSelectOptions,
  speciesClassNameSelectOptions,
  speciesCropSectorOptions,
  denominationStatusOptions,
  getSearchQuery as getQuery,
  getExportNoteQuery,
  autoCompletePostData,
  searchVarietyReturnTypes,
  scrollToRef,
  renderTooltipOverlay,
  updateObject,
  searchFieldLabels,
  API_URLS,
  testDateBefore,
  overrideStrings,
  calcPercentage,
  downloadBlob,
  getCountries,
  handleCountriesChange,
  COUNTRIES_SESSION_KEY,
  LAST_SEARCH_SESSION_KEY,
  registerNameSelectOptions,
  downloadExcelFileNames,
  downloadExcelWorksheetTitles,
  getCpvoStats,
  validDenominationOptions,
  sleep,
  isFullSearchExp,
  compareResults
} from "../../shared/utility";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { generatexlx } from "../../exportXls";
import SearchFormContainer from "../../components/UI/SearchFormContainer/SearchFormContainer";
import ResultsHeader from "../../components/UI/ResultsHeader/ResultsHeader";
import SearchSpecies from "../SearchSpecies/SearchSpecies";
import CustomModal from "../../components/UI/CustomModal/CustomModal";
import SaveSearchModal from "../../components/UI/SaveSearchModal/SaveSearchModal";
import { connect } from "react-redux";
import { ISavedSearch } from "../../components/Header/Header";
import useSessionStorage from "../../hooks/useSessionStorage";
import { useAlert } from "../../shared/AlertService";
import SearchClasses from "../SearchClasses/SearchClasses";
import { useMatomo } from '@datapunt/matomo-tracker-react';
import ScrollToTopArrow from "../../components/UI/ScrollToTopArrow/ScrollToTopArrow";
import CustomCountUp from "../../components/UI/CustomCountUp/CustomCountUp";

const SearchVarieties = (props: any) => {
  const { trackPageView } = useMatomo()

  // Track page view
  React.useEffect(() => {
    trackPageView({documentTitle:'Search Varieties'})
    // eslint-disable-next-line
  }, [])

  const { t, i18n } = useTranslation();

  const [saveSearchModalDisplay, setSaveSearchModalDisplay] = React.useState(
    false
  );
  const [saveSearchModalInput, setSaveSearchModalInput] = React.useState<any>(
    {}
  );

  const [countriesOptions, setCountriesOptions] = useState<ICountryOption[]>(
    []
  );
  const [searchInit, setSearchInit] = React.useState(false);
  const searchInitRef = React.useRef(false);
  searchInitRef.current = searchInit;

  const [exportNoteData, setExportNoteData] = useState<INoteData | null>(null);

  const resultsRef = React.useRef(null);

  const [activeTab, setActiveTab] = React.useState(0);
  const activeTabRef = React.useRef(activeTab);
  activeTabRef.current = activeTab;

  const changeTab = React.useCallback((newTab) => {
    setActiveTab(newTab);
  }, []);

  const setSearchForm = (useSearch: any) => {
    const storedValues = restoreSavedSearchFormattedValues(useSearch.searchTerms);
    setInitialValues(updateObject(initialValues, {...storedValues}));
    // @ts-ignore
    formikRef.current?.resetForm();
    const storedKeyValues = Object.keys(useSearch.searchTerms);
    setSelectedFields(selectedFields.map((field: any) => {
      const enabled = storedKeyValues.includes(field.name);
      return updateObject(field, {enabled: enabled});
    }))
  }

  useEffect(() => {
    const sessionCountries = sessionStorage.getItem(COUNTRIES_SESSION_KEY);

    if (sessionCountries) {
      setCountriesOptions(JSON.parse(sessionCountries));
    } else {
      getCountries(setCountriesOptions);
    }

    const sessionItem = sessionStorage.getItem(LAST_SEARCH_SESSION_KEY);
    if (sessionItem) {
      setSearchForm({ searchTerms: JSON.parse(JSON.parse(sessionItem)) });
    }

  }, []);

  useEffect(() => {
    if (props.savedSearchesInitialized && !searchInitRef.current) {
      const sessionItem = sessionStorage.getItem(LAST_SEARCH_SESSION_KEY);
      if (!sessionItem && props.savedSearches && props.savedSearches.length) {
        const defaultSearch = props.savedSearches.find((search: any) => search.isDefault);
        if (defaultSearch) {
          setSearchForm(defaultSearch);
        }
      }
      setSearchInit(true);
    }
    if (props.savedSearches?.length) {
      const selected = props.savedSearches.find((search:any)=>search.isSelected);
      if (selected) {
        setSearchForm(selected);
        props.onClearSelectedSavedSearch();
      }
    }
  }, [props.savedSearchesInitialized, props.savedSearches])

  useEffect(() => {
    if (props.lastSearch && Object.keys(props.lastSearch).length) {
      const storedValues = restoreSavedSearchFormattedValues(props.lastSearch);
      setInitialValues(updateObject(initialValues, { ...storedValues }));
      const storedKeyValues = Object.keys(props.lastSearch);
      setSelectedFields(
        selectedFields.map((field: any) => {
          const enabled = storedKeyValues.includes(field.name);
          return updateObject(field, { enabled: enabled });
        })
      );
    }
  }, [props.lastSearch]);

  useEffect(() => {
    if (props.location.state) {
      props.onSelectSavedSearch(props.location.state)
    }
  }, [props.location.state]);

  const [formValues, setFormValues] = useState([]);
  const [data, setData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [totalCount2, setTotalCount2] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [sortBy, setSortBy] = useState([]);
  const [completedPromises, setCompletedPromises] = useState<number>(0);

  const [generateExcel, setGenerateExcel] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [, setLastSearch] = useSessionStorage("lastSearch", "");
  const [displayResults, setDisplayResults] = useState(false);

  const [downloadModalShow, setDownloadModalShow] = useState(false);
  const [excelModalShow, setExcelModalShow] = useState(false);

  const handleDownloadModalClose = () => setDownloadModalShow(false);
  const handleDownloadModalShow = () => setDownloadModalShow(true);

  const handleExcelModalClose = () => setExcelModalShow(false);
  const handleExcelModalShow = () => setExcelModalShow(true);

  const fetchData = React.useCallback(
    ({ pageSize: tablePageSize, pageIndex: tablePageIndex, sortBy: tableSortBy, values, tableColumns: columns }) => {
      setData([]);
      setSelectedColumns(columns);
      setPageIndex(tablePageIndex);
      setSortBy(tableSortBy);
      setIsLoading(true);
      const promiseArray: Array<Promise<any>> = [];
      promiseArray.push(
        graphQLClientInstance.post(
          API_URLS.GRAPHQL,
          getQuery(values, tablePageSize, tablePageIndex, tableSortBy, columns, (activeTabRef.current === 1))
        )
      );
      
      if (tablePageIndex === 0) {
        setPageCount(0);
        setTotalCount(0);
        setTotalCount2(0);
        if (!isFullSearchExp()) {
          promiseArray.push(
            graphQLClientInstance.post(
              API_URLS.GRAPHQL,
              getQuery(values, tablePageSize, tablePageIndex, tableSortBy, columns, !(activeTabRef.current === 1))
            )
          );
        }
      }
      axios.all(promiseArray).then(axios.spread((...res) => {
        const resData = (activeTabRef.current === 0) ? res[0]?.data?.data?.searchVariety : res[0].data?.data?.searchVarietyCom;
        if (tablePageIndex === 0) {
          if (resData?.hasOwnProperty('total')) {
            setTotalCount(resData.total);
          }
          if (!isFullSearchExp()) {
            const resData2 = (activeTabRef.current === 1) ? res[1].data?.data?.searchVariety : res[1].data?.data?.searchVarietyCom;
            if (resData2?.hasOwnProperty('total')) {
              setTotalCount2(resData2.total);
            }
          }
        }
        if (resData?.hasOwnProperty('total')) {
          setPageCount(Math.ceil(resData.total / tablePageSize));
        }
        if (resData?.data) {
          setData(resData.data);
        }
        setIsLoading(false);
        setDisplayResults(true);
        scrollToRef(resultsRef);
      }))
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
    },
    []
  );

  const limiter = new Bottleneck({
    minTime: 200,
    maxConcurrent: 3,
  });

  const completedPromisesRef = React.useRef(completedPromises);

  const generatePromises = async (
    sortBy: any,
    values: any,
    totalItems: number,
    totalItems2: number,
    columns: any
  ) => {
    completedPromisesRef.current = 0;
    let i = 0;
    let pageIdx = 0;
    const promiseArray: Array<Promise<any>> = [];
    while (i < totalItems) {
      const body = getQuery(values, 1000, pageIdx, sortBy, columns, (activeTabRef.current === 1));
      const promise = limiter.schedule(() =>
        graphQLClientInstance.post(API_URLS.GRAPHQL, body)
      );
      promiseArray.push(promise);
      i += 1000;
      pageIdx++;
    }
    i = 0;
    pageIdx = 0;
    while (i < totalItems2) {
      const body = getQuery(values, 1000, pageIdx, sortBy, columns, !(activeTabRef.current === 1));
      const promise = limiter.schedule(() =>
        graphQLClientInstance.post(API_URLS.GRAPHQL, body)
      );
      promiseArray.push(promise);
      i += 1000;
      pageIdx++;
    }

    let dataArr: Array<any> = [];
    await axios.all(promiseArray).then(
      axios.spread((...res) => {
        dataArr = res.map((r) => {
          if (r.data.data.searchVariety?.data) {
            return r.data.data.searchVariety?.data;
          } else if (r.data.data.searchVarietyCom?.data) {
            return r.data.data.searchVarietyCom?.data;    
          }
      }).filter(Boolean);
    }));
    return dataArr;
  };

  const completedPromisesCounter = (count: number) => {
    completedPromisesRef.current = count;
    setCompletedPromises(count);
  };

  // state to keep track of resolved promises
  limiter.on("done", function (info) {
    completedPromisesCounter(completedPromisesRef.current + 1);
  });

  const downloadExcel = async ({ values }: { values: any }) => {
    setGenerateExcel(false);
    let myData: any[] = [];
    await generatePromises(sortBy, values, totalCount, totalCount2, selectedColumns)
      .then((res) => {
        if (res) {
          myData = res;
        }
      })
      .catch((err) => {
        console.log(err);
      });

    const flattenData: any[] = myData.flat(2);
    if (totalCount2 > 0 && sortBy.length) {
      flattenData.sort(compareResults(sortBy[0]));
    }
    const limitedData: any[] = [];
    const limitsCounters: INumArray = {};

    exportNoteData?.data.forEach((element) => {
      limitsCounters[element.register] = element.max_records;
    });

    flattenData.forEach((element) => {
      if (element?.register in limitsCounters) {
        if (limitsCounters[element.register] > 0) {
          limitedData.push(element);
          limitsCounters[element.register]--;
        }
      } else {
        limitedData.push(element);
      }
    });

    let file = "";
    setGenerateExcel(true);
    await sleep(500);
    file = await generatexlx(
      limitedData,
      selectedColumns
        .filter((item) => item.enabled)
        .map((item: any) => {
          return item.name;
        }),
      downloadExcelWorksheetTitles.SEARCH_VARIETIES_WORKSHEET
    ).catch((err) => {
      console.log(err);
    });

    if (file) {
      const blob = new Blob([file], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      downloadBlob(blob, downloadExcelFileNames.SEARCH_VARIETIES);
    }
    setExcelModalShow(false);
  };

  useEffect(() => {
    if (exportNoteData) {
      handleDownloadModalShow();
    }
  }, [exportNoteData]);

  useEffect(() => {
    if (completedPromises) {
      handleExcelModalShow();
    }
  }, [completedPromises]);

  const alert = useAlert();

  const setIsLoadingCB = React.useCallback(
    (status: boolean) => {
      setIsLoading(status);
    },
    []
  );

  const exportNote = React.useCallback(
    ({ values }) => {
      if (totalCount === 0 && totalCount2 === 0) return;
      if (totalCount + totalCount2 > 50000) {
        alert({
          catchOnCancel: false,
          title: t("alert"),
          body: t("redefine_search"),
        });
      } else {
        graphQLClientInstance
          .post(API_URLS.EXPORT_NOTE, getExportNoteQuery(values))
          .then((res) => {
            const resData = res.data.map((limit: INoteResponse) => {
              const limitExtended: INoteExtended = {
                ...limit,
                exported_records: 0,
              };
              limitExtended.exported_records =
                limitExtended.recordsinSearch < limit.max_records ||
                limitExtended.max_records < 0
                  ? limitExtended.recordsinSearch
                  : limitExtended.max_records;
              return limitExtended;
            });
            const limitedExported = resData.reduce(
              (accumulator: number, currentValue: INoteExtended) =>
                Number(accumulator) + Number(currentValue.exported_records),
              []
            );
            const limitedRegistersTotal = resData.reduce(
              (accumulator: number, currentValue: INoteExtended) =>
                Number(accumulator) + Number(currentValue.recordsinSearch),
              []
            );
            const registersWithoutLimits =
              Number(totalCount) + Number(totalCount2) - Number(limitedRegistersTotal);
            const exported =
              limitedExported + registersWithoutLimits > 50000
                ? 50000
                : limitedExported + registersWithoutLimits;
            setExportNoteData({ exported: exported, data: resData });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    [totalCount, totalCount2]
  );

  const [speciesModalState, setSpeciesModalState] = useState(false);

  const addSpecies = () => {
    setSpeciesModalState(true);
  };

  const [speciesClassesModalState, setSpeciesClassesModalState] = useState(false);
  const [speciesClassesModalOrigin, setSpeciesClassesModalOrigin] = useState("");

  const speciesClassesModalOriginRef = React.useRef("");
  speciesClassesModalOriginRef.current = speciesClassesModalOrigin;

  const addSpeciesClasses = (field: string) => {
    setSpeciesClassesModalOrigin(field);
    setSpeciesClassesModalState(true);
  }

  const formikRef = React.useRef();

  const selectedSpeciesData = React.useCallback(({ selectedSpecies }) => {
    if (formikRef.current) {
      // @ts-ignore

      formikRef.current.setFieldValue(
        "speciesLatinName",
        [
          // @ts-ignore
          ...formikRef.current.values.speciesLatinName,
          ...selectedSpecies.map((val: any) => {
            return { customOption: true, value: val.princ_bot };
          }),
        ].filter(
          (v: any, i: any, a: any) =>
            a.findIndex((item:any) => item.value === v.value) === i
        )
      );
    }
    setSpeciesModalState(false);
  }, []);

  const selectedSpeciesClassesData = React.useCallback(({selectedSpeciesClasses}) => {
    if (formikRef.current) {
      switch (speciesClassesModalOriginRef.current) {
        case addFromListOrigin.SPECIES_CLASS_CODE:
          // @ts-ignore
          formikRef.current.setFieldValue(
            "speciesClassCode",
            [
              // @ts-ignore
              ...formikRef.current.values.speciesClassCode,
              ...selectedSpeciesClasses.map((val: any) => {
                return { customOption: true, value: val.classid };
              })
            ].filter(
              (v: any, i: any, a: any) =>
                a.findIndex((item: any) => item.value === v.value) === i
            )
          );
          break;
        case addFromListOrigin.SPECIES_CLASS_NAME:
          // @ts-ignore
          formikRef.current.setFieldValue(
            "speciesClassName",
            [
              // @ts-ignore
              ...formikRef.current.values.speciesClassName,
              ...selectedSpeciesClasses.map((val: any) => {
                  return { customOption: true, value: val.classname };
                })
              ].filter(
                (v: any, i: any, a: any) =>
                  a.findIndex((item: any) => item.value === v.value) === i
              )
            );
          break;
      }
    }
    setSpeciesClassesModalState(false);
  },[]);


  const speciesModal = (
    <CustomModal
      show={speciesModalState}
      onHide={() => {
        setSpeciesModalState(false);
      }}
    >
      <SearchSpecies modal={true} selectedSpeciesData={selectedSpeciesData} />
    </CustomModal>
  );

  const speciesClassesModal = (
    <CustomModal show={speciesClassesModalState} onHide={()=> {setSpeciesClassesModalState(false)}}>
      <SearchClasses
        modal={true}
        selectedSpeciesClassesData={selectedSpeciesClassesData}
      />
    </CustomModal>
  )

  const DenominationField = (formik: any) => (
    <Col md="12" id="denominationContainer" key="denominationContainer">
      <Form.Group controlId="searchForm.denomination">
        <Form.Label className="w-100">
          {t("denomination")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.denomination"),
            <InfoCircleLightIcon />
          )}
        </Form.Label>
        <InputGroup>
          <CustomDropdown
            name="denominationSelect"
            label="denominationSelect"
            as={InputGroup.Prepend}
            id="dropdown-denomination"
            value={formik.values.denominationSelect}
            options={denominationSelectOptions()}
            setFieldValue={formik.setFieldValue}
          />
          <FormControl
            name="denomination"
            as="input"
            type="text"
            placeholder={t("search_varieties.denomination_placeholder")}
            value={formik.values.denomination}
            onChange={formik.handleChange}
            onBlur={(evt: React.SyntheticEvent) => {
              (evt.target as HTMLInputElement).value = (evt.target as HTMLInputElement).value.trim();
              formik.handleChange(evt);
            }}
          />
        </InputGroup>
      </Form.Group>
    </Col>
  );

  const SpeciesLatinNameField = (formik: any) => (
    <Col md="8" id="speciesLatinNameContainer" key="speciesLatinNameContainer">
      <Form.Group controlId="searchForm.speciesLatinName">
        <label
          className="form-label w-100"
          htmlFor="searchForm.speciesLatinName"
        >
          <div className="float-left" style={{ marginRight: "2rem" }}>
            {t("species_latin_name")}
          </div>
          <div className={[classes.synonyms, "form-check"].join(" ")}>
            <input
              type="checkbox"
              id="searchForm.speciesLatinNameCheck"
              checked={formik.values.includeSynonyms}
              onChange={(evt: React.SyntheticEvent) =>
                formik.setFieldValue(
                  "includeSynonyms",
                  (evt.target as HTMLInputElement).checked
                )
              }
              className="form-check-input"
            />
            <label
              title=""
              htmlFor="searchForm.speciesLatinNameCheck"
              className="form-check-label"
            >
              {t("include_synonyms")}
            </label>
            <div className="d-inline-block">
              <Button
                style={{
                  marginLeft: "12px",
                  marginBottom: "0.15rem",
                  fontSize: "12px",
                  padding: "0px 10px",
                  border: 0,
                }}
                variant="primary"
                onClick={() => addSpecies()}
              >
                {t("add_from_list")}
              </Button>
            </div>
            {renderTooltipOverlay(
              t("tooltips_search_varieties.species_latin_name"),
              <InfoCircleLightIcon />
            )}
          </div>
        </label>
        <InputGroup className="mb-3">
          <CustomDropdown
            name="speciesLatinNameSelect"
            label="SpeciesLatinNameSelect"
            as={InputGroup.Prepend}
            id="dropdown-species-latin-name"
            value={formik.values.speciesLatinNameSelect}
            options={speciesLatinNameSelectOptions()}
            setFieldValue={formik.setFieldValue}
          />
          <CustomAsyncTypehead
            allowNew
            multiple
            clearButton
            useCache={false}
            newSelectionPrefix={t("typeahead_new_selection")}
            selected={formik.values.speciesLatinName}
            name="speciesLatinName"
            id="speciesLatinNameTypeahead"
            label={t("species_latin_name")}
            postUrl={API_URLS.GRAPHQL}
            postData={autoCompletePostData}
            selectFieldValue={formik.values.speciesLatinNameSelect}
            includeSynonymsFieldValue={formik.values.includeSynonyms}
            autoCompleteName="autoCompleteSpeciesLatinName"
            autoCompleteReturnString="{ name principal }"
            setFieldValue={formik.setFieldValue}
          />
        </InputGroup>
      </Form.Group>
    </Col>
  );

  const CountriesField = (formik: any) => (
    <Col md="4" id="countriesContainer" key="countriesContainer">
      <Form.Group controlId="searchForm.countries">
        <Form.Label className="w-100">
          {t("countries")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.countries"),
            <InfoCircleLightIcon />
          )}
        </Form.Label>
        <MultiSelect
          onChange={(val: any) => {
            handleCountriesChange(val, formik.values.countries, formik.countriesOptions, formik.setFieldValue, "countries");
          }}
          value={formik.values.countries}
          labelledBy="countries"
          className="customMultiSelect"
          options={formik.countriesOptions}
          disableSearch={false}
          overrideStrings={overrideStrings()}
        />
      </Form.Group>
    </Col>
  );

  const DenominationNatureField = (formik: any) => (
    <Col
      md="4"
      id="denominationNatureContainer"
      key="denominationNatureContainer"
    >
      <Form.Group controlId="searchForm.denominationNature">
        <Form.Label className="w-100">
          {t("denomination_nature")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.denomination_nature"),
            <InfoCircleLightIcon />
          )}
        </Form.Label>
        <MultiSelect
          onChange={(val: any) =>
            formik.setFieldValue("denominationNature", val)
          }
          value={formik.values.denominationNature}
          className="customMultiSelect"
          options={denomNatureOptions()}
          disableSearch={true}
          overrideStrings={overrideStrings()}
          labelledBy="denominationNature"
        />
      </Form.Group>
    </Col>
  );

  const VarietyStatusField = (formik: any) => (
    <Col md="4" id="varietyStatusContainer" key="varietyStatusContainer">
      <Form.Group controlId="searchForm.varietyStatus">
        <Form.Label className="w-100">
          {t("variety_status")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.variety_status"),
            <InfoCircleLightIcon />
          )}
        </Form.Label>

        <MultiSelect
          onChange={(val: any) => formik.setFieldValue("varietyStatus", val)}
          value={formik.values.varietyStatus}
          className="customMultiSelect"
          options={varietyStatusOptions()}
          disableSearch={true}
          overrideStrings={overrideStrings()}
          labelledBy="varietyStatus"
        />
      </Form.Group>
    </Col>
  );

  const RegisterTypeField = (formik: any) => (
    <Col md="4" id="registerTypeContainer" key="registerTypeContainer">
      <Form.Group controlId="searchForm.registerType">
        <Form.Label className="w-100">
          {t("register_type")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.register_type"),
            <InfoCircleLightIcon />
          )}
        </Form.Label>

        <MultiSelect
          onChange={(val: any) => formik.setFieldValue("registerType", val)}
          value={formik.values.registerType}
          className="customMultiSelect"
          options={registerTypeOptions(false)}
          disableSearch={true}
          overrideStrings={overrideStrings()}
          labelledBy="registerType"
        />
      </Form.Group>
    </Col>
  );

  const BreedersReferenceField = (formik: any) => (
    <Col
      md="4"
      id="breedersReferenceContainer"
      key="breedersReferenceContainer"
    >
      <Form.Group controlId="searchForm.breedersReference">
        <Form.Label className="w-100">
          {t("breeders_reference")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.breeders_reference"),
            <InfoCircleLightIcon />
          )}
        </Form.Label>
        <InputGroup className="mb-3">
          <CustomDropdown
            name="breedersReferenceSelect"
            label="BreedersReferenceSelect"
            as={InputGroup.Prepend}
            id="dropdown-breeders-reference"
            options={breedersReferenceSelectOptions()}
            value={formik.values.breedersReferenceSelect}
            setFieldValue={formik.setFieldValue}
          />
          <FormControl
            name="breedersReference"
            as="input"
            type="text"
            value={formik.values.breedersReference}
            onChange={formik.handleChange}
          />
        </InputGroup>
      </Form.Group>
    </Col>
  );

  const BreedersNameField = (formik: any) => (
    <Col md="8" id="breedersNameContainer" key="breedersNameContainer">
      <Form.Group controlId="searchForm.breedersName">
        <Form.Label className="w-100">
          {t("breeders_name")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.breeders_name"),
            <InfoCircleLightIcon />
          )}
        </Form.Label>
        <InputGroup className="mb-3">
          <CustomDropdown
            name="breedersNameSelect"
            label="breedersNameSelect"
            as={InputGroup.Prepend}
            id="dropdown-breeders-name"
            options={breederNameSelectOptions()}
            value={formik.values.breedersNameSelect}
            setFieldValue={formik.setFieldValue}
          />
          <CustomAsyncTypehead
            allowNew
            newSelectionPrefix={t("typeahead_new_selection")}
            id="breedersNameTypeahead"
            useCache={false}
            name="breedersName"
            label={t("breeders_name")}
            setFieldValue={formik.setFieldValue}
            postUrl={API_URLS.GRAPHQL}
            postData={autoCompletePostData}
            selectFieldValue={formik.values.breedersNameSelect}
            selected={formik.values.breedersName}
            autoCompleteName="autoCompleteBreederName"
          />
        </InputGroup>
      </Form.Group>
    </Col>
  );

  const PartiesField = (formik: any) => (
    <Col md="12" id="partiesContainer" key="partiesContainer">
      <Form.Group controlId="searchForm.parties">
        <Form.Label className="w-100">
          {t("parties")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.parties"),
            <InfoCircleLightIcon />
          )}
        </Form.Label>
        <InputGroup className="mb-3">
          <CustomDropdown
            name="partiesSelect"
            label="partiesSelect"
            as={InputGroup.Prepend}
            id="dropdown-parties"
            options={partiesSelectOptions()}
            value={formik.values.partiesSelect}
            setFieldValue={formik.setFieldValue}
          />
          <CustomAsyncTypehead
            allowNew
            newSelectionPrefix={t("typeahead_new_selection")}
            id="partiesTypeahead"
            useCache={false}
            name="parties"
            label={t("parties")}
            setFieldValue={formik.setFieldValue}
            postUrl={API_URLS.GRAPHQL}
            postData={autoCompletePostData}
            selectFieldValue={formik.values.partiesSelect}
            selected={formik.values.parties}
            autoCompleteName="autoCompleteParties"
          />
        </InputGroup>
      </Form.Group>
    </Col>
  );

  const ApplicationNumberField = (formik: any) => (
    <Col
      md="4"
      id="applicationNumberContainer"
      key="applicationNumberContainer"
    >
      <Form.Group controlId="searchForm.applicationNumber">
        <Form.Label className="w-100">
          {t("application_number")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.application_number"),
            <InfoCircleLightIcon />
          )}
        </Form.Label>
        <InputGroup className="mb-3">
          <CustomDropdown
            name="applicationNumberSelect"
            label="applicationNumberSelect"
            as={InputGroup.Prepend}
            id="dropdown-application-number"
            options={applicationNumberSelectOptions()}
            value={formik.values.applicationNumberSelect}
            setFieldValue={formik.setFieldValue}
          />
          <CustomAsyncTypehead
            allowNew
            newSelectionPrefix={t("typeahead_new_selection")}
            id="applicationNumberTypeahead"
            useCache={false}
            name="applicationNumber"
            label={t("application_number")}
            setFieldValue={formik.setFieldValue}
            postUrl={API_URLS.GRAPHQL}
            postData={autoCompletePostData}
            selectFieldValue={formik.values.applicationNumberSelect}
            selected={formik.values.applicationNumber}
            autoCompleteName="autoCompleteApplicationNumber"
          />
        </InputGroup>
      </Form.Group>
    </Col>
  );

  const ApplicationDateField = (formik: any) => (
    <Col md="4" id="applicationDateContainer" key="applicationDateContainer">
      <Form.Group>
        <Form.Label className="w-100">
          {t("application_date")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.application_date"),
            <InfoCircleLightIcon />
          )}
        </Form.Label>
        <CustomDatePicker
          maximumDate={calendarToday()}
          name="applicationDate"
          controlId="searchForm.applicationDate"
          setFieldValue={formik.setFieldValue}
          value={formik.values.applicationDate}
          invalid={
            formik.errors.applicationDate && formik.touched.applicationDate
          }
        />
        <Form.Control.Feedback type="invalid">
          {formik.errors.applicationDate}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  );

  const ApplicationPubDateField = (formik: any) => (
    <Col
      md="4"
      id="applicationPubDateContainer"
      key="applicationPubDateContainer"
    >
      <Form.Group>
        <Form.Label className="w-100">
          {t("application_pub_date")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.application_pub_date"),
            <InfoCircleLightIcon />
          )}
        </Form.Label>
        <CustomDatePicker
          maximumDate={calendarToday()}
          name="applicationPubDate"
          controlId="searchForm.applicationPubDate"
          setFieldValue={formik.setFieldValue}
          value={formik.values.applicationPubDate}
          invalid={
            formik.errors.applicationPubDate &&
            formik.touched.applicationPubDate
          }
        />
        <Form.Control.Feedback type="invalid">
          {formik.errors.applicationPubDate}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  );

  const GrantRegistrationNumberField = (formik: any) => (
    <Col
      md="4"
      id="grantRegistrationNumberContainer"
      key="grantRegistrationNumberContainer"
    >
      <Form.Group controlId="searchForm.grantRegistrationNumber">
        <Form.Label className="w-100">
          {t("grant_registration_number")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.grant_registration_number"),
            <InfoCircleLightIcon />
          )}
        </Form.Label>
        <InputGroup className="mb-3">
          <CustomDropdown
            name="grantRegistrationNumberSelect"
            label="grantRegistrationNumberSelect"
            as={InputGroup.Prepend}
            id="dropdown-grant-registration-number"
            options={applicationNumberSelectOptions()}
            value={formik.values.grantRegistrationNumberSelect}
            setFieldValue={formik.setFieldValue}
          />
          <CustomAsyncTypehead
            allowNew
            newSelectionPrefix={t("typeahead_new_selection")}
            id="grantRegistrationNumberTypeahead"
            useCache={false}
            name="grantRegistrationNumber"
            label={t("grant_registration_number")}
            setFieldValue={formik.setFieldValue}
            postUrl={API_URLS.GRAPHQL}
            postData={autoCompletePostData}
            selectFieldValue={formik.values.grantRegistrationNumberSelect}
            selected={
              Array.isArray(formik.values.grantRegistrationNumber)
                ? formik.values.grantRegistrationNumber
                : []
            }
            autoCompleteName="autoCompleteGrantNumber"
          />
        </InputGroup>
      </Form.Group>
    </Col>
  );

  const GrantRegistrationDateField = (formik: any) => (
    <Col
      md="4"
      id="grantRegistrationDateContainer"
      key="grantRegistrationDateContainer"
    >
      <Form.Group>
        <Form.Label className="w-100">
          {t("grant_registration_date")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.grant_registration_date"),
            <InfoCircleLightIcon />
          )}
        </Form.Label>
        <CustomDatePicker
          maximumDate={calendarToday()}
          name="grantRegistrationDate"
          controlId="searchForm.grantRegistrationDate"
          setFieldValue={formik.setFieldValue}
          value={formik.values.grantRegistrationDate}
          invalid={
            formik.errors.grantRegistrationDate &&
            formik.touched.grantRegistrationDate
          }
        />
        <Form.Control.Feedback type="invalid">
          {formik.errors.grantRegistrationDate}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  );

  const GrantRegistrationPubDateField = (formik: any) => (
    <Col
      md="4"
      id="grantRegistrationPubDateContainer"
      key="grantRegistrationPubDateContainer"
    >
      <Form.Group>
        <Form.Label className="w-100">
          {t("grant_registration_pub_date")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.grant_registration_pub_date"),
            <InfoCircleLightIcon />
          )}
        </Form.Label>
        <CustomDatePicker
          maximumDate={calendarToday()}
          name="grantRegistrationPubDate"
          controlId="searchForm.grantRegistrationPubDate"
          setFieldValue={formik.setFieldValue}
          value={formik.values.grantRegistrationPubDate}
          invalid={
            formik.errors.grantRegistrationPubDate &&
            formik.touched.grantRegistrationPubDate
          }
        />
        <Form.Control.Feedback type="invalid">
          {formik.errors.grantRegistrationPubDate}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  );

  const RenewalDateField = (formik: any) => (
    <Col md="4" id="renewalDateContainer" key="renewalDateContainer">
      <Form.Group>
        <Form.Label className="w-100">
          {t("renewal_date")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.renewal_date"),
            <InfoCircleLightIcon />
          )}
        </Form.Label>
        <CustomDatePicker
          maximumDate={calendarToday()}
          name="renewalDate"
          controlId="searchForm.renewalDate"
          setFieldValue={formik.setFieldValue}
          value={formik.values.renewalDate}
          invalid={formik.errors.renewalDate && formik.touched.renewalDate}
        />
        <Form.Control.Feedback type="invalid">
          {formik.errors.renewalDate}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  );

  const VarietyInsertionDateField = (formik: any) => (
    <Col
      md="4"
      id="varietyInsertionDateContainer"
      key="varietyInsertionDateContainer"
    >
      <Form.Group>
        <Form.Label className="w-100">
          {t("variety_insertion_date")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.variety_insertion_date"),
            <InfoCircleLightIcon />
          )}
        </Form.Label>
        <CustomDatePicker
          maximumDate={calendarToday()}
          name="varietyInsertionDate"
          controlId="searchForm.varietyInsertionDate"
          setFieldValue={formik.setFieldValue}
          value={formik.values.varietyInsertionDate}
          invalid={
            formik.errors.varietyInsertionDate &&
            formik.touched.varietyInsertionDate
          }
        />
        <Form.Control.Feedback type="invalid">
          {formik.errors.varietyInsertionDate}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  );

  const DenominationInsertionDateField = (formik: any) => (
    <Col
      md="4"
      id="denominationInsertionDateContainer"
      key="denominationInsertionDateContainer"
    >
      <Form.Group>
        <Form.Label className="w-100">
          {t("denomination_insertion_date")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.denomination_insertion_date"),
            <InfoCircleLightIcon />
          )}
        </Form.Label>
        <CustomDatePicker
          maximumDate={calendarToday()}
          name="denominationInsertionDate"
          controlId="searchForm.denominationInsertionDate"
          setFieldValue={formik.setFieldValue}
          value={formik.values.denominationInsertionDate}
          invalid={
            formik.errors.denominationInsertionDate &&
            formik.touched.denominationInsertionDate
          }
        />
        <Form.Control.Feedback type="invalid">
          {formik.errors.denominationInsertionDate}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  );

  const addSpeciesClassesButton = (field: string) => (
    <div className="d-inline-block">
      <Button
      style={{
        marginLeft: "12px",
        marginBottom: "0.15rem",
        fontSize: "12px",
        padding: "0px 10px",
        border: 0}}
        variant="primary"
        onClick={() => addSpeciesClasses(field)}>{t("add_from_list")}</Button>
    </div>
  )

  const SpeciesClassCodeField = (formik: any) => (
    <Col md="4" id="speciesClassCodeContainer" key="speciesClassCodeContainer">
      <Form.Group controlId="searchForm.speciesClassCode">
        <Form.Label className="w-100">
          {t("species_class_code")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.species_code"),
            <InfoCircleLightIcon />
          )}
          {formik.values.speciesClassCodeSelect === selectOptions.EXACT ?
            addSpeciesClassesButton(addFromListOrigin.SPECIES_CLASS_CODE)
          : (
            <></>
          )}
        </Form.Label>
        <InputGroup className="mb-3">
          <CustomDropdown
            name="speciesClassCodeSelect"
            label="speciesClassCodeSelect"
            as={InputGroup.Prepend}
            id="dropdown-species-class-code"
            options={speciesClassCodeSelectOptions()}
            value={formik.values.speciesClassCodeSelect}
            setFieldValue={formik.setFieldValue}
            clearOnExact={true}
            clearFieldValue={formik.values.speciesClassCode}
            clearFieldName="speciesClassCode"
          />
          {formik.values.speciesClassCodeSelect === selectOptions.EXACT?
            <CustomAsyncTypehead
              allowNew
              newSelectionPrefix={t("typeahead_new_selection")}
              id="speciesClassCodeTypeahead"
              useCache={false}
              name="speciesClassCode"
              label={t("species_code")}
              multiple
              setFieldValue={formik.setFieldValue}
              postUrl={API_URLS.GRAPHQL}
              postData={autoCompletePostData}
              selectFieldValue={formik.values.speciesClassCodeSelect}
              selected={formik.values.speciesClassCode}
              autoCompleteName="autoCompleteSpeciesClassCode"
            />
          :
            <FormControl
              name='speciesClassCode'
              as="input"
              type="text"
              value={formik.values.speciesClassCode}
              onChange={formik.handleChange}
            />
          }
        </InputGroup>
      </Form.Group>
    </Col>
  );

  const SpeciesClassNameField = (formik: any) => (
    <Col md="4" id="speciesClassNameContainer" key="speciesClassNameContainer">
      <Form.Group controlId="searchForm.speciesClassName">
        <Form.Label className="w-100">
          {t("species_class_name")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.species_class_name"),
            <InfoCircleLightIcon />
          )}
          {formik.values.speciesClassNameSelect === selectOptions.EXACT ?
            addSpeciesClassesButton(addFromListOrigin.SPECIES_CLASS_NAME)
          : (
            <></>
          )}
        </Form.Label>
        <InputGroup className="mb-3">
          <CustomDropdown
            name="speciesClassNameSelect"
            label="speciesClassNameSelect"
            as={InputGroup.Prepend}
            id="dropdown-species-class-name"
            options={speciesClassNameSelectOptions()}
            value={formik.values.speciesClassNameSelect}
            setFieldValue={formik.setFieldValue}
            clearOnExact={true}
            clearFieldValue={formik.values.speciesClassName}
            clearFieldName="speciesClassName"
          />
          {formik.values.speciesClassNameSelect === selectOptions.EXACT?
            <CustomAsyncTypehead
              allowNew
              newSelectionPrefix={t("typeahead_new_selection")}
              id="speciesClassNameTypeahead"
              useCache={false}
              multiple
              name="speciesClassName"
              label={t("species_class_name")}
              setFieldValue={formik.setFieldValue}
              postUrl={API_URLS.GRAPHQL}
              postData={autoCompletePostData}
              selectFieldValue={formik.values.speciesClassNameSelect}
              selected={formik.values.speciesClassName}
              autoCompleteName="autoCompleteSpeciesClass"
            />
          :
            <FormControl
              name='speciesClassName'
              as="input"
              type="text"
              value={formik.values.speciesClassName}
              onChange={formik.handleChange}
            />
          }
        </InputGroup>
      </Form.Group>
    </Col>
  );

  const SpeciesCropSectorField = (formik: any) => (
    <Col
      md="4"
      id="speciesCropSectorContainer"
      key="speciesCropSectorContainer"
    >
      <Form.Group controlId="searchForm.speciesCropSector">
        <Form.Label className="w-100">
          {t("species_crop_sector")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.species_crop_sector"),
            <InfoCircleLightIcon />
          )}
        </Form.Label>
        <MultiSelect
          onChange={(val: any) =>
            formik.setFieldValue("speciesCropSector", val)
          }
          value={formik.values.speciesCropSector}
          className="customMultiSelect"
          options={speciesCropSectorOptions()}
          disableSearch={true}
          overrideStrings={overrideStrings()}
          labelledBy="speciesCropSector"
        />
      </Form.Group>
    </Col>
  );

  const DenominationStatusField = (formik: any) => (
    <Col
      md="4"
      id="denominationStatusContainer"
      key="denominationStatusContainer"
    >
      <Form.Group controlId="searchForm.denominationStatus">
        <Form.Label className="w-100">
          {t("denomination_status")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.denomination_status"),
            <InfoCircleLightIcon />
          )}
        </Form.Label>
        <MultiSelect
          onChange={(val: any) =>
            formik.setFieldValue("denominationStatus", val)
          }
          value={formik.values.denominationStatus}
          className="customMultiSelect"
          options={denominationStatusOptions()}
          disableSearch={true}
          overrideStrings={overrideStrings()}
          labelledBy="denominationStatus"
        />
      </Form.Group>
    </Col>
  );

  const RegisterNameField = (formik: any) => (
    <Col md="4" id="registerNameContainer" key="registerNameContainer">
      <Form.Group controlId="searchForm.registerName">
        <Form.Label className="w-100">
          {t("register_name")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.register_name"),
          <InfoCircleLightIcon />)}
        </Form.Label>
        <InputGroup className="mb-3">
          <CustomDropdown
            name='registerNameSelect'
            label="registerNameSelect"
            as={InputGroup.Prepend}
            id="dropdown-register-name"
            options={registerNameSelectOptions()}
            value={formik.values.registerNameSelect}
            setFieldValue={formik.setFieldValue}
          />
          <CustomAsyncTypehead
            allowNew
            newSelectionPrefix={t("typeahead_new_selection")}
            id='registerNameTypeahead'
            useCache={false}
            name='registerName'
            label={t("register_name")}
            setFieldValue={formik.setFieldValue}
            postUrl={API_URLS.GRAPHQL}
            postData={autoCompletePostData}
            selectFieldValue={formik.values.registerNameSelect}
            selected={formik.values.registerName}
            autoCompleteName="autoCompleteRegisterName"
          />
        </InputGroup>
      </Form.Group>
    </Col>
  )

  const ValidDenominationField = (formik: any) => (
    <Col md="4" id="registeredWithOtherContainer" key="registeredWithOtherContainer">
      <Form.Group controlId="searchForm.registeredWithOther">
        <Form.Label className="w-100">
          {t("valid_denomination")}
          {renderTooltipOverlay(
            t("tooltips_search_varieties.valid_denomination"),
            <InfoCircleLightIcon />
          )}
        </Form.Label>
        <Form.Control
          as="select"
          value={formik.values.registeredWithOther}
          name="registeredWithOther"
          onChange={formik.handleChange}
        >
          {validDenominationOptions()
          .map((validDenomination: any, index: number) => {
            return (
              <option key={`valid-denomination-option-${index}`} value={validDenomination.value}>
                {validDenomination.label}
              </option>
            )
          })}
        </Form.Control>
      </Form.Group>
    </Col>
  )

  const [selectedFields, setSelectedFields] = useState([
    {
      name: "denomination",
      nameSelect: "denominationSelect",
      value: DenominationField,
      label: <Translation>{(translate) => translate("denomination")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 0,
    },
    {
      name: "speciesLatinName",
      nameSelect: "speciesLatinNameSelect",
      nameCheck: "includeSynonyms",
      value: SpeciesLatinNameField,
      label: <Translation>{(translate) => translate("species_latin_name")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 2,
    },
    {
      name: "countries",
      value: CountriesField,
      label: <Translation>{(translate) => translate("countries")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 3,
    },
    {
      name: "denominationNature",
      value: DenominationNatureField,
      label: <Translation>{(translate) => translate("denomination_nature")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 4,
    },
    {
      name: "varietyStatus",
      value: VarietyStatusField,
      label: <Translation>{(translate) => translate("variety_status")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 5,
    },
    {
      name: "registerType",
      value: RegisterTypeField,
      label: <Translation>{(translate) => translate("register_type")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 6,
    },
    {
      name: "breedersReference",
      nameSelect: "breedersReferenceSelect",
      value: BreedersReferenceField,
      label: <Translation>{(translate) => translate("breeders_reference")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 6,
    },
    {
      name: "breedersName",
      nameSelect: "breedersNameSelect",
      value: BreedersNameField,
      label: <Translation>{(translate) => translate("breeders_name")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 7,
    },
    {
      name: "speciesCropSector",
      value: SpeciesCropSectorField,
      label: <Translation>{(translate) => translate("species_crop_sector")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 8,
    },
    {
      name: "parties",
      nameSelect: "partiesSelect",
      value: PartiesField,
      label: <Translation>{(translate) => translate("parties")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 9,
    },
    {
      name: "applicationNumber",
      nameSelect: "applicationNumberSelect",
      value: ApplicationNumberField,
      label: <Translation>{(translate) => translate("application_number")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 10,
    },
    {
      name: "applicationDate",
      value: ApplicationDateField,
      label: <Translation>{(translate) => translate("application_date")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 11,
    },
    {
      name: "applicationPubDate",
      value: ApplicationPubDateField,
      label: <Translation>{(translate) => translate("application_pub_date")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 12,
    },
    {
      name: "grantRegistrationNumber",
      nameSelect: "grantRegistrationNumberSelect",
      value: GrantRegistrationNumberField,
      label: <Translation>{(translate) => translate("grant_registration_number")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 13,
    },
    {
      name: "grantRegistrationDate",
      value: GrantRegistrationDateField,
      label: <Translation>{(translate) => translate("grant_registration_date")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 14,
    },
    {
      name: "grantRegistrationPubDate",
      value: GrantRegistrationPubDateField,
      label: (
        <Translation>{(translate) => translate("grant_registration_pub_date")}</Translation>
      ),
      enabled: false,
      isDefault: false,
      defaultOrder: 15,
    },
    {
      name: "renewalDate",
      value: RenewalDateField,
      label: <Translation>{(translate) => translate("renewal_date")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 16,
    },
    {
      name: "varietyInsertionDate",
      value: VarietyInsertionDateField,
      label: <Translation>{(translate) => translate("variety_insertion_date")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 17,
    },
    {
      name: "denominationInsertionDate",
      value: DenominationInsertionDateField,
      label: (
        <Translation>{(translate) => translate("denomination_insertion_date")}</Translation>
      ),
      enabled: false,
      isDefault: false,
      defaultOrder: 18,
    },
    {
      name: "speciesClassCode",
      nameSelect: "speciesClassCodeSelect",
      value: SpeciesClassCodeField,
      label: <Translation>{(translate) => translate("species_class_code")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 19,
    },
    {
      name: "speciesClassName",
      nameSelect: "speciesClassNameSelect",
      value: SpeciesClassNameField,
      label: <Translation>{(translate) => translate("species_class_name")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 20,
    },
    {
      name: "denominationStatus",
      value: DenominationStatusField,
      label: <Translation>{(translate) => translate("denomination_status")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 21,
    },
    {
      name: "registerName",
      nameSelect: "registerNameSelect",
      value: RegisterNameField,
      label: <Translation>{(translate) =>  translate("register_name")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 22,
    },
    {
      name: "registeredWithOther",
      value: ValidDenominationField,
      label: <Translation>{(translate) => translate("valid_denomination")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 23,
    }
  ]);

  const getSavedSearchFormattedValues = (formikValues: any) => {
    const savedValues: any = {};

    selectedFields
      .filter((field) => field.enabled)
      .forEach((field) => {
        const savedValue: any = {};
        if (field.name in formikValues) {
          savedValue.name = formikValues[field.name];
        }
        if (field.nameSelect && field.nameSelect in formikValues) {
          savedValue.nameSelect = formikValues[field.nameSelect];
        }
        if (field.nameCheck && field.nameCheck in formikValues) {
          savedValue.nameCheck = formikValues[field.nameCheck];
        }
        savedValues[field.name] = savedValue;
      });

    return savedValues;
  };

  const restoreSavedSearchFormattedValues = (formikValues: any) => {
    const formValues: any = {};

    Object.keys(formikValues).forEach((fieldName) => {
      if (formikValues[fieldName].hasOwnProperty("name")) {
        formValues[fieldName] = formikValues[fieldName]["name"];
      }
      if (
        formikValues[fieldName].hasOwnProperty("nameSelect") &&
        searchFieldLabels[fieldName] &&
        searchFieldLabels[fieldName]["nameSelect"]
      ) {
        // @ts-ignore
        formValues[searchFieldLabels[fieldName]["nameSelect"]] =
          formikValues[fieldName]["nameSelect"];
      }
      if (
        formikValues[fieldName].hasOwnProperty("nameCheck") &&
        searchFieldLabels[fieldName] &&
        searchFieldLabels[fieldName]["nameCheck"]
      ) {
        // @ts-ignore
        formValues[searchFieldLabels[fieldName]["nameCheck"]] =
          formikValues[fieldName]["nameCheck"];
      }
    });

    return formValues;
  };

  const initialSelectedColumns = [
    {
      name: searchVarietyReturnTypes.DENOMINATION,
      label: <Translation>{(translate) => translate("denomination")}</Translation>,
      enabled: true,
      disabled: true,
      isDefault: true,
      defaultOrder: 0,
    },
    {
      name: searchVarietyReturnTypes.DENOMINATION_NATURE,
      label: <Translation>{(translate) => translate("denomination_nature")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 2,
    },
    {
      name: searchVarietyReturnTypes.SPECIES_LATIN_NAME,
      label: <Translation>{(translate) => translate("species_latin_name")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 3,
      extraFieldData: searchVarietyReturnTypes.SPECIES_CODE
    },
    {
      name: searchVarietyReturnTypes.SPECIES_CLASS_CODE,
      label: <Translation>{(translate) => translate("species_class_code")}</Translation>,
      enabled: false,
      isDefault: true,
      defaultOrder: 4,
      extraFieldData: searchVarietyReturnTypes.SPECIES_CLASS_NAME,
    },
    {
      name: searchVarietyReturnTypes.SPECIES_CLASS_NAME,
      label: <Translation>{(translate) => translate("species_class_name")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 5,
    },
    {
      name: searchVarietyReturnTypes.COUNTRIES,
      label: <Translation>{(translate) => translate("countries")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 6,
      extraFieldData: searchVarietyReturnTypes.COUNTRY_NAME,
    },
    {
      name: searchVarietyReturnTypes.REGISTER_TYPE,
      label: <Translation>{(translate) => translate("register_type")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 7,
      extraFieldData: searchVarietyReturnTypes.REGISTER_TYPE_NAME,
    },
    {
      name: searchVarietyReturnTypes.VARIETY_STATUS_TEXT,
      label: <Translation>{(translate) => translate("variety_status")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 8,
    },
    {
      name: searchVarietyReturnTypes.DENOMINATION_STATUS,
      label: <Translation>{(translate) => translate("denomination_status")}</Translation>,
      enabled: false,
      isDefault: true,
      defaultOrder: 9,
    },
    {
      name: searchVarietyReturnTypes.APPLICATION_NUMBER,
      label: <Translation>{(translate) => translate("application_number")}</Translation>,
      enabled: true,
      disabled: true,
      isDefault: true,
      defaultOrder: 10,
    },
    {
      name: searchVarietyReturnTypes.APPLICATION_DATE,
      label: <Translation>{(translate) => translate("application_date")}</Translation>,
      enabled: false,
      dataType: "date",
      isDefault: true,
      defaultOrder: 11,
    },
    {
      name: searchVarietyReturnTypes.GRANT_REGISTRATION_DATE,
      label: <Translation>{(translate) => translate("grant_registration_date")}</Translation>,
      enabled: false,
      dataType: "date",
      isDefault: true,
      defaultOrder: 12,
    },
    {
      name: searchVarietyReturnTypes.BREEDERS_REFERENCE,
      label: <Translation>{(translate) => translate("breeders_reference")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 13,
    },
    {
      name: searchVarietyReturnTypes.BREEDERS_NAME,
      label: <Translation>{(translate) => translate("breeders_name")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 14,
    },
    {
      name: searchVarietyReturnTypes.APPLICANT,
      label: <Translation>{(translate) => translate("applicant")}</Translation>,
      enabled: true,
      isDefault: false,
      defaultOrder: 15,
    },
    {
      name: searchVarietyReturnTypes.APPLICATION_PUB_DATE,
      label: <Translation>{(translate) => translate("application_pub_date")}</Translation>,
      enabled: false,
      dataType: "date",
      isDefault: false,
      defaultOrder: 16,
    },
    {
      name: searchVarietyReturnTypes.HOLDER,
      label: <Translation>{(translate) => translate("holder")}</Translation>,
      enabled: true,
      isDefault: false,
      defaultOrder: 17,
    },
    {
      name: searchVarietyReturnTypes.GRANT_REGISTRATION_NUMBER,
      label: <Translation>{(translate) => translate("grant_registration_number")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 18,
    },
    {
      name: searchVarietyReturnTypes.GRANT_REGISTRATION_PUB_DATE,
      label: (
        <Translation>{(translate) => translate("grant_registration_pub_date")}</Translation>
      ),
      enabled: false,
      dataType: "date",
      isDefault: false,
      defaultOrder: 19,
    },
    {
      name: searchVarietyReturnTypes.MAINTAINER,
      label: <Translation>{(translate) => translate("maintainer")}</Translation>,
      enabled: true,
      isDefault: false,
      defaultOrder: 20,
    },
    {
      name: searchVarietyReturnTypes.VARIETY_INSERTION_DATE,
      label: <Translation>{(translate) => translate("variety_insertion_date")}</Translation>,
      enabled: false,
      dataType: "date",
      isDefault: false,
      defaultOrder: 21,
    },
    {
      name: searchVarietyReturnTypes.DENOMINATION_INSERTION_DATE,
      label: (
        <Translation>{(translate) => translate("denomination_insertion_date")}</Translation>
      ),
      enabled: false,
      dataType: "date",
      isDefault: false,
      defaultOrder: 22,
    },
    {
      name: searchVarietyReturnTypes.SPECIES_CODE,
      label: <Translation>{(translate) => translate("species_code")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 23,
    },
    {
      name: searchVarietyReturnTypes.EXPIRATION_ACTUAL,
      label: <Translation>{(translate) => translate("expiration_actual")}</Translation>,
      enabled: false,
      dataType: "date",
      isDefault: false,
      defaultOrder: 24,
    },
    {
      name: searchVarietyReturnTypes.FUTURE_EXPIRATION_DATE,
      label: (
        <Translation>{(translate) => translate("future_calc_expiration_date")}</Translation>
      ),
      enabled: false,
      dataType: "date",
      isDefault: false,
      defaultOrder: 25,
    },
    {
      name: searchVarietyReturnTypes.DENOMINATION_TYPE,
      label: <Translation>{(translate) => translate("denomination_type")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 26,
    },
    {
      name: searchVarietyReturnTypes.DENOMINATION_PROPOSAL_DATE,
      label: (
        <Translation>{(translate) => translate("denomination_proposal_date")}</Translation>
      ),
      enabled: false,
      dataType: "date",
      isDefault: false,
      defaultOrder: 27,
    },
    {
      name: searchVarietyReturnTypes.DENOMINATION_PUBLISHED_DATE,
      label: (
        <Translation>{(translate) => translate("denomination_published_date")}</Translation>
      ),
      enabled: false,
      dataType: "date",
      isDefault: false,
      defaultOrder: 28,
    },
    {
      name: searchVarietyReturnTypes.DENOMINATION_APPROVAL_DATE,
      label: (
        <Translation>{(translate) => translate("denomination_approval_date")}</Translation>
      ),
      enabled: false,
      dataType: "date",
      isDefault: false,
      defaultOrder: 29,
    },
    {
      name: searchVarietyReturnTypes.DENOMINATION_END_DATE,
      label: <Translation>{(translate) => translate("denomination_end_date")}</Translation>,
      enabled: false,
      dataType: "date",
      isDefault: false,
      defaultOrder: 30,
    },
    {
      name: searchVarietyReturnTypes.SPECIES_NAME_EN,
      label: <Translation>{(translate) => translate("species_english_name")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 31,
    },
    {
      name: searchVarietyReturnTypes.RENEWAL_DATE,
      label: <Translation>{(translate) => translate("renewal_date")}</Translation>,
      enabled: false,
      dataType: "date",
      isDefault: false,
      defaultOrder: 32,
    },
    {
      name: searchVarietyReturnTypes.OTHER_PARTIES,
      label: <Translation>{(translate) => translate("other_parties")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 33,
    },
    {
      name: searchVarietyReturnTypes.REMARKS,
      label: <Translation>{(translate) => translate("remarks")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 34,
    },
    {
      name: searchVarietyReturnTypes.EXTRA_DATA_URL,
      label: <Translation>{(translate) => translate("extra_data_url")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 36,
    },
    {
      name: searchVarietyReturnTypes.REGISTER_NAME,
      label: <Translation>{(translate) => translate("register_name")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 37,
    },
    {
      name: searchVarietyReturnTypes.SPECIES_CROP_SECTOR,
      label: <Translation>{(translate) => translate("species_crop_sector")}</Translation>,
      enabled: false,
      isDefault: false,
      defaultOrder: 38,
    },
  ];

  const setLocalStorageOrder = (
    initValues: any[],
    sortingArray: { name: string; enabled: boolean }[]
  ) => {
    return initValues
      .map((item) => {
        item.enabled = sortingArray.find(
          (storedItem) => item.name === storedItem.name
        )?.enabled;
        return item;
      })
      .sort((a, b) => {
        return (
          sortingArray.findIndex((x) => x.name === a.name) -
          sortingArray.findIndex((y) => y.name === b.name)
        );
      });
  };

  const [localSearchVarietyColumns, setLocalSearchVarietyColumns] = useSettings(
    "searchVarietyColumns",
    initialSelectedColumns.map((item) => {
      return { name: item.name, enabled: item.enabled };
    })
  );

  const [selectedColumns, setSelectedColumns] = useState(
    setLocalStorageOrder(initialSelectedColumns, localSearchVarietyColumns)
  );

  React.useEffect(() => {
    setLocalSearchVarietyColumns(
      selectedColumns.map((item) => {
        return { name: item.name, enabled: item.enabled };
      })
    );
  }, [selectedColumns]);

  const formInitialValues = {
    denominationSelect: selectOptions.STARTS,
    denomination: "",
    registeredWithOther: "",
    includeSynonyms: true,
    speciesLatinNameSelect: selectOptions.CONTAINS,
    speciesLatinName: [],
    countries: [],
    denominationNature: [],
    breedersReferenceSelect: selectOptions.CONTAINS,
    breedersReference: "",
    breedersNameSelect: selectOptions.CONTAINS,
    breedersName: [],
    varietyStatus: [],
    registerType: [],
    partiesSelect: selectOptions.CONTAINS,
    parties: [],
    applicationNumberSelect: selectOptions.EXACT,
    applicationNumber: [],
    grantRegistrationNumberSelect: selectOptions.EXACT,
    grantRegistrationNumber: [],
    speciesClassNameSelect: selectOptions.STARTS,
    speciesClassName: [],
    speciesClassCodeSelect: selectOptions.STARTS,
    speciesClassCode: [],
    speciesCropSector: [],
    denominationStatus: [],
    applicationDate: [],
    applicationPubDate: [],
    grantRegistrationDate: [],
    grantRegistrationPubDate: [],
    renewalDate: [],
    varietyInsertionDate: [],
    denominationInsertionDate: [],
    registerNameSelect: selectOptions.EXACT,
    registerName: []
  };

  const [initialValues, setInitialValues] = useState<{ [key: string]: any }>(
    formInitialValues
  );

  const form = (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      // @ts-ignore
      innerRef={formikRef}
      validationSchema={Yup.object().shape({
        applicationDate: Yup.array()
          .of(
            Yup.object().shape({
              type: Yup.mixed()
                .oneOf(["from", "to"] as const)
                .required(),
              value: Yup.string().required(),
            })
          )
          .test(
            "isDateBefore",
            t(DATE_BEFORE_ERROR_TRANSLATION_KEY),
            testDateBefore
          ),
        applicationPubDate: Yup.array()
          .of(
            Yup.object().shape({
              type: Yup.mixed()
                .oneOf(["from", "to"] as const)
                .required(),
              value: Yup.string().required(),
            })
          )
          .test(
            "isDateBefore",
            t(DATE_BEFORE_ERROR_TRANSLATION_KEY),
            testDateBefore
          ),
        grantRegistrationDate: Yup.array()
          .of(
            Yup.object().shape({
              type: Yup.mixed()
                .oneOf(["from", "to"] as const)
                .required(),
              value: Yup.string().required(),
            })
          )
          .test(
            "isDateBefore",
            t(DATE_BEFORE_ERROR_TRANSLATION_KEY),
            testDateBefore
          ),
        grantRegistrationPubDate: Yup.array()
          .of(
            Yup.object().shape({
              type: Yup.mixed()
                .oneOf(["from", "to"] as const)
                .required(),
              value: Yup.string().required(),
            })
          )
          .test(
            "isDateBefore",
            t(DATE_BEFORE_ERROR_TRANSLATION_KEY),
            testDateBefore
          ),
        renewalDate: Yup.array()
          .of(
            Yup.object().shape({
              type: Yup.mixed()
                .oneOf(["from", "to"] as const)
                .required(),
              value: Yup.string().required(),
            })
          )
          .test(
            "isDateBefore",
            t(DATE_BEFORE_ERROR_TRANSLATION_KEY),
            testDateBefore
          ),
        varietyInsertionDate: Yup.array()
          .of(
            Yup.object().shape({
              type: Yup.mixed()
                .oneOf(["from", "to"] as const)
                .required(),
              value: Yup.string().required(),
            })
          )
          .test(
            "isDateBefore",
            t(DATE_BEFORE_ERROR_TRANSLATION_KEY),
            testDateBefore
          ),
        denominationInsertionDate: Yup.array()
          .of(
            Yup.object().shape({
              type: Yup.mixed()
                .oneOf(["from", "to"] as const)
                .required(),
              value: Yup.string().required(),
            })
          )
          .test(
            "isDateBefore",
            t(DATE_BEFORE_ERROR_TRANSLATION_KEY),
            testDateBefore
          ),
      })}
      onSubmit={(values: any, { setFieldValue, setSubmitting }) => {
        selectedFields.forEach((field: any) => {
          if (!field.enabled) {
            // @ts-ignore
            values[field.name] = formInitialValues[field.name];
            if (field.nameSelect) {
              // @ts-ignore
              values[field.nameSelect] = formInitialValues[field.nameSelect];
            }
            if (field.nameCheck) {
              // @ts-ignore
              values[field.nameCheck] = formInitialValues?.[field.nameCheck];
            }
          }
        });
        const payload = {
          ...values,
          activeTab: activeTabRef.current
        };

        setLastSearch(JSON.stringify(getSavedSearchFormattedValues(values)));
        props.onSetLastSearch(getSavedSearchFormattedValues(values));

        setPageIndex(0);
        setFormValues(payload);
        setSubmitting(false);
        setExportNoteData(null);
        setIsLoading(true);
        setDisplayResults(true);
      }}
    >
      {(formProps) => (
        <Form
          className={classes.searchForm}
          onSubmit={(e) => {
            formProps.handleSubmit();
            e.preventDefault();
          }}
        >
          <Row className={classes.searchFieldsRow}>
            {selectedFields
              .filter((item) => item.enabled)
              .map((item) => {
                if (item.name === "countries") {
                  return item.value({ ...formProps, countriesOptions });
                } else {
                  return item.value(formProps);
                }
              })}
          </Row>
          <Row className={classes.actionsRow}>
            <Col md="12">
              <CustomSortablePopover
                id="search-fields-reorder"
                placement="right"
                onPopoverExited={setSelectedFields}
                items={selectedFields}
              >
                <Button
                  id="configureSearchFields"
                  variant="link"
                  className="float-left pl-0"
                >
                  <FontAwesomeIcon icon={["fas", "cog"]} className="mr-2" />
                  {t("configure_search_fields")}
                </Button>
              </CustomSortablePopover>
              <Button
                id="submitSearchForm"
                variant="primary"
                type="submit"
                disabled={formProps.isSubmitting}
                className="float-right"
              >
                {t("search")}
              </Button>
              <Button
                id="saveSearch"
                onClick={() => {
                  setSaveSearchModalInput(
                    getSavedSearchFormattedValues(formProps.values)
                  );
                  setSaveSearchModalDisplay(true);
                }}
                variant="outline-primary"
                className="float-right mr-2"
              >
                {t("save_search")}
              </Button>
              <Button
                id="clearFields"
                variant="link"
                onClick={() => {
                  setInitialValues(formInitialValues);
                  formProps.resetForm();
                }}
                className="float-right mr-2"
              >
                {t("clear_fields")}
              </Button>
              <Button
                id="help"
                variant="link"
                onClick={() => window.open(`help/${i18n.language}/Search_varieties.html`, '_blank')}
                className="float-right mr-2">
                  {t("help")}
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );

  const modal = (
    <Modal centered show={downloadModalShow} onHide={handleDownloadModalClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("export_note_title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {t("export_note_export_total", {
          exported: isFullSearchExp() ? exportNoteData?.exported : (totalCount + totalCount2),
          total: totalCount + totalCount2,
        })}
        <br/><br/>
        <div>{t("export_note_msg")}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={handleDownloadModalClose}>
          {t("cancel")}
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            downloadExcel({ values: formValues });
            handleDownloadModalClose();
          }}
        >
          {t("complete_export")}
        </Button>
      </Modal.Footer>
    </Modal>
  );

  const tableColumns = React.useMemo(() => {
    return [
      {
        name: searchVarietyReturnTypes.DENOMINATION_SYNONYM,
        label: "",
        accessor: searchVarietyReturnTypes.DENOMINATION_SYNONYM,
        Header: "",
        enabled: true,
      },
      ...selectedColumns.map((item: any) => {
        return { ...item, Header: item.label, accessor: item.name };
      }),
    ];
  }, [selectedColumns]);

  const progressInst = (
    <ProgressBar
      className="w-100"
      now={calcPercentage(completedPromises, (totalCount + totalCount2) / 1000)}
      label={`${calcPercentage(completedPromises, (totalCount + totalCount2) / 1000)}%`}
    />
  );

  const downloadExcelModal = (
    <Modal
      centered
      keyboard={false}
      backdrop="static"
      show={excelModalShow}
      onHide={handleExcelModalClose}
    >
      <Modal.Header>
        <Modal.Title>{t("downloading_results")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {progressInst}
        <div>
          {generateExcel?
            <>
              {t("generate_excel")} <Spinner animation="border" size="sm" variant="primary" />
            </>
          :""}
        </div>
      </Modal.Body>
    </Modal>
  );

  const [cpvoStats, setCpvoStats] = React.useState<any>(getCpvoStats());

  React.useEffect(() => {
    // @ts-ignore
    setFormValues({...formValues, activeTab: activeTab});
  }, [activeTab]);

  React.useEffect(() => {
    if (!Object.keys(cpvoStats).length) {
      graphQLClientInstance.get(API_URLS.STATS)
      .then(res => {
        sessionStorage.setItem("cpvo_stats", JSON.stringify(res.data));
        setCpvoStats(res.data);
      })
      .catch(err => {
        console.log(err);
      });
    }
  }, [cpvoStats])

  const statsSection = (end: number, translationKey: string) => {
    return <span className={["d-inline-block", classes.yellowUnderline].join(" ")}><CustomCountUp end={end}/> {t(translationKey, {count: 2})}</span>
  }

  return (
    <>
      <Loader show={isLoading}></Loader>
      <SaveSearchModal
        onAddSavedSearch={props.onAddSavedSearch}
        show={saveSearchModalDisplay}
        setShow={setSaveSearchModalDisplay}
        input={saveSearchModalInput}
      />
      <CustomBackground image="varieties">
        <SearchFormContainer
          title={t("search_varieties.title")}
          subtitle={<span>
                      {t("search_among")}{' '}
                      {statsSection(cpvoStats.denominations, "denomination")}{', '}
                      {statsSection(cpvoStats.varieties, "variety")}{', '}
                      {statsSection(cpvoStats.registers, "register")}{' '}
                      {t("in")}{' '}
                      {statsSection(cpvoStats.countries, "countries")}
                    </span>}
        >
          {form}
        </SearchFormContainer>
      </CustomBackground>
      {speciesModal}
      {speciesClassesModal}
      {displayResults ? (
        <Container
          fluid
          style={{
            display: !(isLoading && totalCount === 0 && totalCount2 === 0) ? "block" : "none",
          }}
        >

          <ResultsHeader totalCount={totalCount + totalCount2} resultsRef={resultsRef} />
          {!isFullSearchExp() && <div className={[classes.excludedVarieties, "excluded-varieties-msg"].join(" ")}>
            {t('varieties_excluded_results_msg')}
          </div>}
          <Table
            columns={tableColumns}
            data={data}
            origin={tableOrigin.SEARCH_VARIETIES}
            fetchData={fetchData}
            downloadExcel={exportNote}
            pageCount={pageCount}
            firstColumnWithoutHeader={true}
            totalCount={totalCount}
            pageIndex={pageIndex}
            formValues={formValues}
            showPagination={true}
            showTableActionsBottom={true}
            setIsLoading={setIsLoadingCB}
            changeTab={changeTab}
            activeTab={activeTab}
            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
          />
          <ScrollToTopArrow/>
          {modal}
          {downloadExcelModal}
        </Container>
      ) : (
        <></>
      )}
    </>
  );
};

export interface ICountryOption {
  label: string;
  value: string;
}

interface INoteResponse {
  register: string;
  publicationname: string;
  max_records: number;
  recordsinSearch: number;
}

interface INoteExtended extends INoteResponse {
  exported_records: number;
}

interface INoteData {
  exported: number;
  data: INoteExtended[];
}

interface INumArray {
  [key: string]: number;
}

const mapStateToProps = (state: any) => {
  return {
    savedSearches: state.savedSearches.items,
    savedSearchesInitialized: state.savedSearches.initialized,
    lastSearch: state.lastSearch.fields,
  };
};

const addFromListOrigin = {
  SPECIES_CLASS_CODE: 'speciesClassCode',
  SPECIES_CLASS_NAME: 'speciesClassName'
}

const DATE_BEFORE_ERROR_TRANSLATION_KEY = "error_messages.date_before";

const mapDispatchToProps = (dispatch: any) => {
  return {
    onAddSavedSearch: (savedSearch: ISavedSearch) =>
      dispatch(actions.addSavedSearch(savedSearch)),
    onClearSelectedSavedSearch: () =>
      dispatch(actions.clearSelectedSavedSearch()),
    onSetLastSearch: (lastSearch: any) =>
      dispatch(actions.setLastSearch(lastSearch)),
    onSelectSavedSearch: (savedSearch: ISavedSearch) =>
      dispatch(actions.selectSavedSearch(savedSearch)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SearchVarieties));
